import { BaseWebComponentElement } from '../../../../../framework/BaseWebComponentElement';
import { ContactDetailsSectionController } from '../controller/ContactDetailsSectionController';
import { Observable } from 'rxjs';
import {
  ContactDetailsSectionViewData,
  MdrContactDetailsSectionValuePrivate,
  MdrContactDetailsSectionValuePublic,
} from '../types/ContactDetailsSectionViewData';
import { FormGroup } from '../../../../../ui/gzForm/formGroup/form-group';
import { MdrContactImportSourceValue } from '../../common/types';

export class ContactDetailsSectionWebComponent extends BaseWebComponentElement {
  public controller!: ContactDetailsSectionController;

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ContactDetailsSectionController,
    });
  }

  public get viewData(): ContactDetailsSectionViewData | undefined {
    const attributeValue = this.getAttribute('data-view-data');
    return attributeValue ? JSON.parse(attributeValue) : undefined;
  }

  public set viewData(value: ContactDetailsSectionViewData | undefined) {
    if (typeof value !== 'undefined') {
      this.setAttribute('data-view-data', JSON.stringify(value));
    } else {
      this.removeAttribute('data-view-data');
    }
  }

  public get valid$(): Observable<boolean> {
    return this.controller.view.dom.$contactForm.valid$;
  }

  public get valid(): boolean {
    return this.controller.view.dom.$contactForm.valid;
  }

  public getFormValue(): MdrContactDetailsSectionValuePublic {
    const privateFormValue: MdrContactDetailsSectionValuePrivate = this.controller.view.formGroup
      .value as unknown as MdrContactDetailsSectionValuePrivate;

    const { hasVerifiedEmailAddress, ...publicValue } = privateFormValue;

    return publicValue as MdrContactDetailsSectionValuePublic;
  }

  public setFormValue(value: Partial<MdrContactDetailsSectionValuePublic>): void {
    const currentImportOptions = this.controller.view.dom.$importOptions.storedValue;
    const {
      importedCompanyId = currentImportOptions.importedCompanyId,
      importedAccountId = currentImportOptions.importedAccountId,
      ...formValue
    } = value;

    this.controller.view.dom.$contactForm.setFormValue(formValue);

    const storedFormGroupValue = { importedCompanyId, importedAccountId } as MdrContactImportSourceValue;
    this.controller.view.dom.$importOptions.setStoredFormGroupValue(storedFormGroupValue);
  }

  public refreshInitialFormValue(): void {
    if (!this.controller.view.formGroup) {
      return;
    }

    this.setFormValue({ emailVerificationCode: '' });
    this.controller.view.formGroup.refreshInitialFormValue();
  }

  public getFormGroup(): FormGroup {
    return this.controller.view.formGroup;
  }
}
